import React, { useState } from 'react';
// @ts-ignore
import { Loader } from 'arag-ui-lib';
import { Formik } from 'formik';
import ClaimBankDetailsForm from '../claimBankDetailsForm/claimBankDetailsForm';
import { ObjectOfAny } from '../../reducers/types';

type Props = {
    loading: boolean;
    handleBankUpdate: () => any;
    questions: ObjectOfAny;
    updatingClaimBankAccount: boolean;
    initialValues: ObjectOfAny;
    bankDetailsAnswers: ObjectOfAny;
};

const ClaimBankDetails = (props: Props): JSX.Element => {
    const {
        loading,
        questions,
        initialValues,
        bankDetailsAnswers,
        handleBankUpdate,
        updatingClaimBankAccount,
    } = props;

    const [disabledSubmitButton, setDisabledSubmitButton] =
        useState<boolean>(false);

    if (loading) {
        return <Loader />;
    }
    return (
        <div>
            <Formik
                initialValues={initialValues}
                onSubmit={handleBankUpdate}
                validateOnBlur={!disabledSubmitButton}
                validateOnChange={!disabledSubmitButton}
            >
                <ClaimBankDetailsForm
                    questions={questions}
                    bankDetailsAnswers={bankDetailsAnswers}
                    updatingClaimBankAccount={updatingClaimBankAccount}
                    initialValues={initialValues}
                    setDisabledSubmitButton={setDisabledSubmitButton}
                    disabledSubmitButton={disabledSubmitButton}
                />
            </Formik>
        </div>
    );
};

export default ClaimBankDetails;
